module.exports = __webpack_public_path__ + "static/media/forkRight.a124f01d.png";